import { render, staticRenderFns } from "./pcat3.vue?vue&type=template&id=17398d1a&"
import script from "./pcat3.vue?vue&type=script&lang=js&"
export * from "./pcat3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports